"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgEntitlementsManager = /*#__PURE__*/function () {
  OrgEntitlementsManager.$inject = ["$scope", "$route", "$routeParams", "$location", "userService", "modalService"];
  /* @ngInject */
  function OrgEntitlementsManager($scope, $route, $routeParams, $location, userService, modalService) {
    var _this = this;
    _classCallCheck(this, OrgEntitlementsManager);
    this.$scope = $scope;
    this.$route = $route;
    this.$location = $location;
    this.$routeParams = $routeParams;
    this.modalService = modalService;
    this.views = [{
      id: 'org-entitlements',
      label: 'Overview'
    }, {
      id: 'events',
      label: 'Workspaces'
    }, {
      id: 'per-event-entitlements',
      label: 'Workspace Entitlements',
      hideUnlessActive: true
    }, {
      id: 'assign-entitlement',
      label: 'Assign Entitlement',
      hideUnlessActive: true
    }];
    $scope.$on('CHANGE_TAB', function (event, _ref) {
      var tab = _ref.tab,
        params = _ref.params;
      _this.switchView(tab, params, false);
    });
  }

  /**
   * Sets default view
   *
   */
  return _createClass(OrgEntitlementsManager, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var activeTabIndex = 0;
      if (this.$routeParams.tab) {
        activeTabIndex = this.views.findIndex(function (tab) {
          return tab.id === _this2.$routeParams.tab;
        });
      }
      this.activeViewId = this.views[activeTabIndex].id;
    }

    /**
     * Sets the current active view and initiates the needed data the first time the view is shown
     *
     * @param {string} id - The id of the view to be shown
     */
  }, {
    key: "switchView",
    value: function switchView(id, params) {
      var view = this.views.find(function (view) {
        return view.id === id;
      });
      if (view.id === this.activeViewId) return;
      this.$route.updateParams({
        tab: view.id
      });
      if (params) {
        for (var key in params) {
          if (params.hasOwnProperty(key)) {
            var value = params[key];
            this.$location.search(key, value);
          }
        }
      } else {
        this.$location.url(this.$location.path());
      }
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager', ['backstage.services']).component('bsOrgEntitlementsManager', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-manager.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsManager
}).name;